import API from '../endpoints';
import { useQuery, QueryFunction } from '@tanstack/react-query';
import axios from 'axios';
import { LiveFeed } from '@repo/types/liveFeed';

const CACHE_TIME = Infinity;

export const useLiveFeedQuery = (date: string) => {
  return useQuery({
    queryKey: ['live-feed', { date }],
    queryFn: fetchLiveFeed,
    staleTime: CACHE_TIME,
  });
};

const fetchLiveFeed: QueryFunction<LiveFeed, [string, { date: string }]> = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await axios.get<LiveFeed>(`${API.endpoints.liveFeed}/${params.date}`);
  return data;
};
